var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.17 18.605a1.36 1.36 0 00-.34 0 4.631 4.631 0 01-4.476-4.632A4.64 4.64 0 0117 9.326a4.65 4.65 0 014.647 4.647c-.014 2.507-1.983 4.547-4.477 4.632zM26.549 27.955A14.074 14.074 0 0117 31.667a14.074 14.074 0 01-9.548-3.712c.142-1.332.992-2.635 2.508-3.655 3.881-2.578 10.228-2.578 14.081 0 1.516 1.02 2.366 2.323 2.508 3.655z",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31.667c7.824 0 14.166-6.343 14.166-14.167S24.824 3.333 17 3.333C9.176 3.333 2.833 9.676 2.833 17.5S9.176 31.667 17 31.667z",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.3bc5340abc8cf9a7cd54c32269e8c969.svg";
export { ForwardRef as ReactComponent };